function ChartService() { }
ChartService.prototype = {

	getChartConfig :function(months,dataarray,indicator){
		var myData = {};
            myData.type = 'line';
            if (indicator == 1) {
            	myData.columns = [];
            	myData.columns[0] = dataarray
            }; 
            if (indicator == 2){
            	myData.columns = dataarray;
            }
            ;
		var x ={
              bindto: d3.select('#generalchart'),
                       data:  myData,
                      bar: {
                          width: {
                              ratio: 0.5 // this makes bar width 50% of length between ticks
                          }
                      },
                     axis: months,
                    };
        return x;         
	},
	getChartConfigforBarCharts :function(months,dataarray,div,varcolor){
		var myData = {};
    myData.type = 'bar';
    myData.labels = true;
    myData.columns = [];
    myData.columns = dataarray;
    var x = {
      padding: { 
        bottom: 100,
        top: 30,
    },
      bindto: d3.select(div),
      data:  myData,
      bar: {
          width: {
            ratio: 0.8 // this makes bar width 50% of length between ticks
          },
      },
      axis:months,
      color: {
        pattern: [varcolor]
    }
      };
      return x;         
	}
}
export default new ChartService();